// 接口参数/返回值加密的路径列表，加密接口的请求参数和返回值均会加密
const encryptionInterface = [
  "/member/spc/v1/allMemberInfo/getMemberDetail.do",
  "/member/spc/v1/authentication/find",
  "/member/spc/v1/third_login_provider",
  "/member/spc/v1/allMemberInfo/edit",
  "/member/common/member/invoice/getMemberInvoiceList.do",
  "/member/spc/member/address/deleteMemberAddressByIds.do",
  "/member/common/member/invoice/updateMemberInvoiceIsDefault.do",
  "/member/common/member/invoice/deleteMemberInvoiceByIds.do",
  "/member/common/member/invoice/save.do",
  "/member/spc/v1/SpcMemberCancel/save",
  "/member/spc/v1/baas/member/detail.do",
  "/member/spc/v1/baas/member/deleteEducationInfo.do",
  "/member/spc/v1/baas/member/deleteSpecialPosition.do",
  "/member/spc/v1/collectFolder/delete",
  "/member/spc/member/address/findMemberAddress.do",
  "/member/spc/member/address/getDefaultAddress.do",
  "/member/spc/member/address/updateMemberInvoiceIsDefault.do",
  "/member/spc/member/address/saveMemberAddress.do",
  "/member/spc/v1/allMemberInfo/getMemberInfo.do",
  "/member/spc/v1/societyMember/getSocietyMember"
]

export default encryptionInterface


// WEBPACK FOOTER //
// ./src/api/encryptionInterface.js